export class DialogModelGenerateRDCN {
    constructor(
      public invoiceNumber: any
    ) {}
  }